import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearGroups from "./routes/YearGroups";
import MapLevelsDepartments from "./routes/MapLevelsDepartments";
import MapStudentsToClasses from "./routes/MapStudentsToClasses";
import MapStaffToClasses from "./routes/MapStaffToClasses";
import CourseClassCreation from "./routes/CourseClassCreation";
import PromoteDemoteStudents from "./routes/PromoteDemoteStudents";
import GradingPeriods from "./routes/GradingPeriods";

export default store => ({
  path: "academic-year-transition",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "./modules/AcademicYearTransitionModules"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const module = importedModule1;
      const reducer = module.default;
      const key = module.NAME;
      injectReducer(store, {
        key,
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [
    YearGroups(store),
    MapLevelsDepartments(store),
    MapStudentsToClasses(store),
    MapStaffToClasses(store),
    CourseClassCreation(store),
    PromoteDemoteStudents(store),
    GradingPeriods(store),
  ],
});
